import { } from 'react-redux';

import { Action } from '@reduxjs/toolkit';

import { updateObject } from '../../../../shared/utils';
import * as actionTypes from '../constants/actionTypes';

import { AppAction } from '../../../../store';

import { PagedResponse, KeyValuePair } from '../../../../shared/models';
import { UserActivityEvent } from '../../models';

export interface UserActivityEventsState {
  userActivityEvents: PagedResponse<UserActivityEvent> | undefined,
  userActivityEventsError: null,
  userActivityEventsLoading: boolean,

  userActivityObjectTimeline: PagedResponse<UserActivityEvent> | undefined,
  userActivityObjectTimelineError: null,
  userActivityObjectTimelineLoading: boolean,

  humanReadableEventTypes: Array<KeyValuePair> | undefined,
  humanReadableEventTypesError: null,
  humanReadableEventTypesLoading: boolean,
};

const initialState: UserActivityEventsState = {
  userActivityEvents: undefined,
  userActivityEventsError: null,
  userActivityEventsLoading: false,

  userActivityObjectTimeline: undefined,
  userActivityObjectTimelineError: null,
  userActivityObjectTimelineLoading: false,

  humanReadableEventTypes: undefined,
  humanReadableEventTypesError: null,
  humanReadableEventTypesLoading: false,
};

const getUserActivityEventsStart = (state: UserActivityEventsState, action: AppAction<PagedResponse<UserActivityEvent> | null>) => {
  return updateObject(state, {
    userActivityEvents: null,
    userActivityEventsError: null,
    userActivityEventsLoading: true,
  });
};

const getUserActivityEventsSuccess = (state: UserActivityEventsState, action: AppAction<PagedResponse<UserActivityEvent> | null>) => {
  return updateObject(state, {
    userActivityEvents: action.data,
    userActivityEventsError: null,
    userActivityEventsLoading: false,
  });
};

const getUserActivityEventsFail = (state: UserActivityEventsState, action: AppAction<PagedResponse<UserActivityEvent> | null>) => {
  return updateObject(state, {
    userActivityEvents: null,
    userActivityEventsError: action.error,
    userActivityEventsLoading: false,
  });
};

const getUserActivityObjectTimelineStart = (state: UserActivityEventsState, action: AppAction<PagedResponse<UserActivityEvent> | null>) => {
  return updateObject(state, {
    userActivityObjectTimeline: null,
    userActivityObjectTimelineError: null,
    userActivityObjectTimelineLoading: true,
  });
};

const getUserActivityObjectTimelineSuccess = (state: UserActivityEventsState, action: AppAction<PagedResponse<UserActivityEvent> | null>) => {
  return updateObject(state, {
    userActivityObjectTimeline: action.data,
    userActivityObjectTimelineError: null,
    userActivityObjectTimelineLoading: false,
  });
};

const getUserActivityObjectTimelineFail = (state: UserActivityEventsState, action: AppAction<PagedResponse<UserActivityEvent> | null>) => {
  return updateObject(state, {
    userActivityObjectTimeline: null,
    userActivityObjectTimelineError: action.error,
    userActivityObjectTimelineLoading: false,
  });
};

const getHumanReadableEventTypesStart = (state: UserActivityEventsState, action: AppAction<Array<KeyValuePair> | null>) => {
  return updateObject(state, {
    humanReadableEventTypes: null,
    humanReadableEventTypesError: null,
    humanReadableEventTypesLoading: true,
  });
};

const getHumanReadableEventTypesSuccess = (state: UserActivityEventsState, action: AppAction<Array<KeyValuePair> | null>) => {
  return updateObject(state, {
    humanReadableEventTypes: action.data,
    humanReadableEventTypesError: null,
    humanReadableEventTypesLoading: false,
  });
};

const getHumanReadableEventTypesFail = (state: UserActivityEventsState, action: AppAction<Array<KeyValuePair> | null>) => {
  return updateObject(state, {
    humanReadableEventTypes: null,
    humanReadableEventTypesError: action.error,
    humanReadableEventTypesLoading: false,
  });
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case actionTypes.GET_USER_ACTIVITY_EVENTS_START:
      return getUserActivityEventsStart(state, action as AppAction<PagedResponse<UserActivityEvent> | null>);
    case actionTypes.GET_USER_ACTIVITY_EVENTS_SUCCESS:
      return getUserActivityEventsSuccess(state, action as AppAction<PagedResponse<UserActivityEvent> | null>);
    case actionTypes.GET_USER_ACTIVITY_EVENTS_FAIL:
      return getUserActivityEventsFail(state, action as AppAction<PagedResponse<UserActivityEvent> | null>);

    case actionTypes.GET_USER_ACTIVITY_OBJECT_TIMELINE_START:
      return getUserActivityObjectTimelineStart(state, action as AppAction<PagedResponse<UserActivityEvent> | null>);
    case actionTypes.GET_USER_ACTIVITY_OBJECT_TIMELINE_SUCCESS:
      return getUserActivityObjectTimelineSuccess(state, action as AppAction<PagedResponse<UserActivityEvent> | null>);
    case actionTypes.GET_USER_ACTIVITY_OBJECT_TIMELINE_FAIL:
      return getUserActivityObjectTimelineFail(state, action as AppAction<PagedResponse<UserActivityEvent> | null>);

    case actionTypes.GET_HUMAN_READABLE_EVENT_TYPES_START:
      return getHumanReadableEventTypesStart(state, action as AppAction<Array<KeyValuePair> | null>);
    case actionTypes.GET_HUMAN_READABLE_EVENT_TYPES_SUCCESS:
      return getHumanReadableEventTypesSuccess(state, action as AppAction<Array<KeyValuePair> | null>);
    case actionTypes.GET_HUMAN_READABLE_EVENT_TYPES_FAIL:
      return getHumanReadableEventTypesFail(state, action as AppAction<Array<KeyValuePair> | null>);

    default:
      return state;
  }
};

export default reducer;
